import { Route, Routes } from "react-router-dom";
import { Error404 } from "../errors/components/Error404";
import { ErrorsLayout } from "../errors/ErrorsLayout";
import { AuthLayout } from "./AuthLayout";
import { Login } from "./components/Login";

const AuthPage = () => {
	return (
		<Routes>
			<Route element={<AuthLayout />}>
				<Route path="login" element={<Login />} />
				<Route index element={<Login />} />
				<Route element={<ErrorsLayout />}>
					<Route path="*" element={<Error404 />} />
				</Route>
			</Route>
		</Routes>
	);
};

export { AuthPage };
